// =================================================================
//  TABS CONTROLS
// =================================================================
const tabHeadings = $(".tabs-bar-item");
const tabContents = $(".tab-contents-item");
let defaultShortDescription;
let defaultLongDescription;

$(tabHeadings).each((index) => {
    $(tabHeadings[index]).on("click", (e) => {
        e.stopPropagation();

        if (e.target.classList.contains("selected")) return;

        const tabId = $(e.target).attr("data-tab-id");

        // Remove active class for content
        $(tabContents).each((index) => {
            if (tabContents[index].classList.contains("active")) {
                tabContents[index].classList.remove("active");
            }
        });

        // Remove active class for headings
        $(tabHeadings).each((index) => {
            if (tabHeadings[index].classList.contains("selected")) {
                tabHeadings[index].classList.remove("selected");
            }
        });

        tabContents[parseInt(tabId)].classList.add("active");
        e.target.classList.add("selected");
    });
});

// =================================================================
//  CONTENT UPDATING FOR VARIANTS
// =================================================================
const updateProductTitle = (variant) => {
    // console.log(variant.option_names, variant.option_names.includes("Type", "Vloertype", "Title"));
    if (variant.option_names.includes("Type", "Vloertype", "Title")) return;

    const title = $("#product-title");
    const baseTitle = $(title).html().split("|")[0];

    $(title).html(
        baseTitle +
            variant.options
                .map((option, index) => {
                    return " | " + option;
                })
                .join("")
    );
};

const UpdateCompareAtPrice = (variant) => {
    const priceDisplay = document.querySelector("#compare-per-unit-price");

    let newVolume = parseFloat($(priceDisplay).data("package-contents"));

    if (variant.option_names.includes("Profiellengte")) {
        const index = variant.option_names.indexOf("Profiellengte");
        newVolume = variant.options[index].replace(/\D/g, "");
        newVolume = (parseFloat(newVolume) / 100).toFixed(1);
        priceDisplay.setAttribute("data-package-contents", newVolume);
    }

    let packageContents = newVolume;
    if (isNaN(packageContents)) packageContents = 1;

    const compareAtPrice = variant.compare_at / 100;
    const activePrice = variant.price / 100;

    if (compareAtPrice == 0 || compareAtPrice == null || compareAtPrice == undefined || isNaN(compareAtPrice)) {
        $(priceDisplay).hide();
        $(".savings-banner").hide();
        return;
    }

    // Calculate the new compare at price
    let compareAtPriceDividedByPackage = (compareAtPrice / packageContents).toFixed(2);

    // Display the new compare at price
    $(priceDisplay).html(`Adviesprijs: <span class="price">€${compareAtPriceDividedByPackage.replace(".", ",")}</span>`);

    // Update the amount saved
    const banner = $(".savings-banner");
    const bannerPrice = $(banner).find(".savings__amount");

    const savings = compareAtPrice - activePrice;
    const savingsPercentage = Math.abs((savings / compareAtPrice) * 100).toFixed();

    $(bannerPrice).html(`${savingsPercentage}%`);
};

const updateStockStatus = (metaFields) => {
    // Remove all classes from delivery time
    $(".delivery_time").removeClass("green");
    $(".delivery_time").removeClass("orange");
    $(".delivery_time").removeClass("hidden");

    // Check if the product should show a back in stock message
    let showBackInStockText = false;
    if (metaFields.back_in_stock !== undefined) {
        const backInStockDate = new Date(metaFields.back_in_stock);
        const currentDate = new Date();
        showBackInStockText = backInStockDate > currentDate;
    }

    if (showBackInStockText) {
        //* Product is not in stockand has a 'back in stock' date
        $(".delivery_time").addClass("orange");
        $(".delivery_time p span.sub").show();
        const iconHtml = '<i class="fa-sharp fa-solid fa-circle-xmark orange" style="margin-right: 5px;"></i>';
        $(".delivery_time p span:first-child").html(`${iconHtml} Tijdelijk niet op voorraad`);
        const backInStockDate = new Date(metaFields.back_in_stock).toLocaleDateString("nl-NL");
        $(".delivery_time p span.sub").html("Levering verwacht op " + backInStockDate);
    } else if (metaFields.verzendtijd !== undefined) {
        if (metaFields.verzendtijd !== "1") {
            $(".delivery_time").addClass("orange");
            $(".delivery_time p span.sub").show();
            $(".delivery_time p span:first-child").html("Dit product wordt voor u besteld");
            const deliveryTime = metaFields.verzendtijd.includes("werkdagen") ? metaFields.verzendtijd : metaFields.verzendtijd + " werkdagen";
            $(".delivery_time p span.sub").html("Binnen " + deliveryTime + " geleverd");
        } else {
            $(".delivery_time").addClass("green");
            $(".delivery_time p span:first-child").html("Vandaag besteld, morgen in huis");
            $(".delivery_time p span.sub").hide();
        }
    } else {
        $(".delivery_time p span.sub").show();
        $(".delivery_time").addClass("green");
        const iconHtml = '<i class="fa-sharp fa-solid fa-circle-check" style="color:#419d38; margin-right: 5px;"></i>';
        $(".delivery_time p span:first-child").html(`${iconHtml} Op voorraad`);
        $(".delivery_time p span.sub").html("Binnen 2 tot 4 werkdagen geleverd");
    }
};

const updateProductInfo = (variantUrl = null) => {
    let selectedVariant;
    let variantShortDescriptionAvailable = false;
    let variantLongDescriptionAvailable = false;

    if (variantUrl === null) {
        const urlParams = new URLSearchParams(window.location.search);
        selectedVariant = metaData[urlParams.get("variant")];
    } else {
        selectedVariant = metaData[variantUrl.split("variant=")[1]];
    }

    if (!selectedVariant) return;

    $("#price-varies-from-text").hide();

    // Update the product title
    updateProductTitle(selectedVariant);

    // Update compare-at-price
    UpdateCompareAtPrice(selectedVariant);

    // Loop through options and update product table
    $(variants).each((i, variant) => {
        let variantValue = $(variant).find(".field-value");
        $(variantValue).html(selectedVariant.options[i]);
    });

    // Loop throught metafields and update product table
    const table = $("#product-properties-table");
    const metaFields = selectedVariant.meta;

    // Update stock status
    updateStockStatus(metaFields);

    // Clear all current metafields in the table
    $(table).find(".meta-field").remove();

    // Append metafields to the table
    for (let key in metaFields) {
        if (key == "related_products" || key == "verzendtijd" || key == "pakket_verpakbaar") continue;
        if (key == "short_description" && metaFields[key]) {
            $(".product-description.rte").html(metaFields[key]);
            variantShortDescriptionAvailable = true;
            continue;
        } else if (key == "long_description" && metaFields[key]) {
            $(".long_description").html(metaFields[key]);
            variantLongDescriptionAvailable = true;
            continue;
        }
        const html = `<tr class="meta-field">
      <th class="field-key">${key.charAt(0).toUpperCase() + key.slice(1)}</th>
      <td class="field-value">${metaFields[key]}</td>
    </tr>`;

        $(table).append(html);
    }

    if (!variantShortDescriptionAvailable) {
        $(".product-description.rte").html(defaultShortDescription);
    }
    if (!variantLongDescriptionAvailable) {
        $(".long_description").html(defaultLongDescription);
    }
};

// =================================================================
//  DUPLICATE TITLE IN PRODUCT DESCRIPTION
// =================================================================
$(function () {
    const tabs = $(".product-info-tabs");
    const title = $(tabs).find(".product-title").html();

    $(tabs)
        .find("h5")
        .each((index, element) => {
            if ($(element).html() == title && index == 0) {
                //Remove the element
                $(element).remove();
            }
        });
});

// =================================================================
//  DUPLICATE TITLE IN PRODUCT DESCRIPTION
// =================================================================
$(function () {
    const productDesc = $(".product-description.rte");

    $(productDesc)
        .find("li")
        .each((index, element) => {
            if ($(element).html().includes("2 tot 4 werkdagen ")) {
                //Remove the element
                $(element).remove();
            }
        });
});

// =================================================================
//  EVENT LISTENERS
// =================================================================
const variants = $(".variant-field");
if ($(variants).length > 0) {
    defaultShortDescription = $(".product-description.rte").html();
    defaultLongDescription = $(".long_description").html();
    updateProductInfo();

    $(document.body).on("change", ".options-selection__option-value-input, .options-selection__input-select", (e) => {
        // Workaround for Firefox
        setTimeout(() => {
            updateProductInfo(e.target.baseURI);
        }, 1);
    });
}

$(".products-dropdown-toggle").click(function (e) {
    // get data-target of clicked element
    const targetClass = `#${$(e.currentTarget).data("target")}`;
    const target = $(targetClass);

    $(e.currentTarget).toggleClass("active");
    $(target).toggleClass("hidden");
});
